import { useFlag } from '@simplywallst/unleash';
import { useLocation } from '@/hooks/useLocation';

// TODO: Will clean this up when we release
// Now we need it to have the best SSR version

const ENABLE_HEADER_V2 = true;

const isHeaderV2Enabled = (variantName: string) => {
  return ['variant1', 'variant2', 'variant3', 'variant4'].includes(variantName);
};

export const useHeaderV2 = () => {
  const headerV2Flag = useFlag('mono-company-report-header-v2');
  const location = useLocation();
  const headerVariant = location.query?.headerVariant;

  const variantName = headerVariant || headerV2Flag.variant.name;
  const flagReady = headerV2Flag.ready;

  return {
    loading: ENABLE_HEADER_V2 && !headerVariant && !flagReady,
    hasNewHeader: ENABLE_HEADER_V2 && isHeaderV2Enabled(variantName),
    variantName,
  };
};
